<template>
  <div class="augmented-faq">
    <div class="main-header-title">
      <div>
        <div class="augmented-route hide-in-desktop" onclick="window.history.go(-1)">
          <span><i class="arrow left"></i></span>
          <span class="routeText">Back</span>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-sm-push-1">
            <div class="faq-title">
              <h1>{{ initialdata.faqtitle }}</h1>
              <h3>{{ initialdata.faqsubtitle }}</h3>
            </div>
          </div>
        </div>
        <div class="imge-faq">
          <img v-if="initialdata.faqimage" :src="initialdata.faqimage" alt="hero banner" />
        </div>
        <div class="row">
          <div class="col-xs-10 col-xs-push-1 col-sm-8 col-sm-push-2">
            <div v-for="(item, indexCol) in limitedFaqs" :key="indexCol">
              <collapse>
                <template #title>
                  <h4
                    class="collapse__title--header"
                    v-html="getNumber(indexCol, item.question)"
                  ></h4>
                </template>
                <template #content>
                  <div v-html="item.answer"></div>
                </template>
                <template #indicator>
                  <span class="arrow-mega-menu">
                    <svg class="icon">
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#arrow-icon"
                      ></use>
                    </svg>
                  </span>
                </template>
              </collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-faq',
  props: {
    initialdata: {
      type: Object,
      required: true,
    },
  },
  // {title:"Fiat", subTitle:"500",questionBank:[{qNo:"1", question: "what is your name",answer: "Rathika.s"},{qNo:"2", question: "what is your name",answer: "Rathika.s"}]}
  data: function () {
    return {};
  },
  computed: {
    limitedFaqs() {
      return this.initialdata.faq.slice(0, 15);
    },
  },
  methods: {
    getNumber(index, question) {
      return `${index + 1}. ${question}`;
    },
  },
};
</script>
